<div class="wrapper" #element></div>
@if(sub$|async){}
